import TranslationText from '@Components/Utilities/TranslationText';
import { BaseTypography } from '@Components/MuiWrappers/Typography';
import { useWindowSize } from '../Utilities/WindowSize';
import translator from '@Components/Utilities/Translator';
import EmailAlertsInputForm from '@Components/WantToBuy/EmailAlertsInputForm';
import EmailAlertsTextAlertModal from '@Components/Shared/Modals/EmailAlertsTextAlertModal';
import DeleteConfirmationModal from '@Components/Shared/Modals/EmailAlertDeleteConfirmationModal.jsx';
import { useState, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { ThemedButton } from '@Components/MuiWrappers/Button';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import { smsType } from '@Components/Utilities/SandhillsConstants';

const EmailAlertsListView = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const [showNewForm, setShowNewForm] = useState(false);
    const windowSize = useWindowSize();
    const [editMode, setEditMode] = useState(false);
    const [isAscending, setIsAscending] = useState(true);
    const [catIconClass, setCatIconClass] = useState('fas fa-sort-amount-asc heavy');
    const [manuIconClass, setManuIconClass] = useState('fas fa-sort');
    const [modelIconClass, setModelIconClass] = useState('fas fa-sort');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [alertsToDelete, setAlertsToDelete] = useState([]);
    const [emailAlerts, setEmailAlerts] = useState(props.EmailAlerts);
    const [disableNewForm, setDisableNewForm] = useState(props.showAlertNumberExceededMessage);
    const [validationErrors, setValidationErrors] = useState(props.validationErrors);
    const [showTextAlertForm, setShowTextAlertForm] = useState(false);
    const [showDeletePhoneConfirmation, setShowDeletePhoneConfirmation] = useState(false);
    const [showTextAlertHeader, setShowTextAlertHeader] = useState(props.TextAlertModel.AlertsEnabled && props.TextAlertFeatureEnabled);
    const [showPhoneConfirmation, setShowPhoneConfirmation] = useState(false);
    const [phoneConfirmationCheckFailed, setPhoneConfirmationCheckFailed] = useState(false);
    const [textAlertModel, setTextAlertModel] = useState(props.TextAlertModel);
    const [smsPhone, setSMSPhone] = useState(props.TextAlertModel.PhoneNumber);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [phoneSubscribedSuccess, setPhoneSubscribedSuccess] = useState(false);
    const [phoneRemovedSuccess, setPhoneRemovedSuccess] = useState(false);   
    const intlTelInput = useRef(null);
    const emptyForm = {
        WantToBuyMessageID: 0,
        Model: '',
        ModelIsRequired: props.ModelIsRequired,
        CategoryID: '',
        TypedManufacturer: '',
        EquipmentType: '',
        YearFrom: '',
        YearTo: '',
        PriceLimit: '',
        CurrencyCode: props.formData.CurrencyCode,
        CultureCode: props.formData.CultureCode,
        LanguageID: '',
        AlertTypeID: '',
        PlanningToBuy: '',
        QuantityNeeded: 1,
        FitsToCategoryID: '',
        ShortDescription: '',
        OtherComments: '',
        SerialNumber: '',
        PartNumber: '',
        MileageMin: '',
        MileageMax: '',
        HoursMin: '',
        HoursMax: '',
        HorsepowerMin: '',
        HorsepowerMax: '',
        LengthInFeet: '',
        LengthInInches: '',
        WidthInInches: '',
        TopClassificationID: props.formData.TopClassificationID,
        TopClassificationCategoryID: props.formData.TopClassificationCategoryID,
        showAlertNumberExceededMessage: '',
        UserEnteredLocation: '',
        MaxDistance: '',
        Engine: '',
        AddToWatchlist: true,
        EmailAlertsForAuction: true,
        EmailAlertsForSale: true 
    }

    const currentSite = useRecoilValue(atoms.currentWebsite);

    const showDeletePhoneConfirmationModal = () => {
        setShowDeletePhoneConfirmation(true);
        setShowTextAlertForm(true);
    }

    const editLock = (value) => {
        setEditMode(value);
        setValidationErrors([]);
        setDisableNewForm(value);
    }
    const submitRemoveEAs = () => {
        setShowConfirmationModal(false);
        if (alertsToDelete.length == 1) {
            props.deleteEmailAlert(alertsToDelete[0]);
        } else {
            for (let i = 0; i < alertsToDelete.length; i++) {
                props.deleteEmailAlert(alertsToDelete[i]);
            }
        }
        let copy = [...emailAlerts];
        setEmailAlerts(copy.filter(emailAlert => !alertsToDelete.includes(emailAlert.WantToBuyMessageID)));
        if (props.showAlertNumberExceededMessage && (emailAlerts.length - alertsToDelete.length) < 100) {
            setDisableNewForm(false);
        }
        setAlertsToDelete([]);
    }
    const closeConfirmationModal = (id) => {
        if (alertsToDelete.length == 1) {
            setAlertsToDelete([]);
        }
        setShowConfirmationModal(false);
    }
    const closeTextAlertModal = (e) => {
        setShowTextAlertForm(false);
        setShowDeletePhoneConfirmation(false);
        setPhoneConfirmationCheckFailed(false);
        setShowPhoneConfirmation(false);
        setTextAlertModel(previousState => {
            return {
                ...previousState,
                PhoneNumber: smsPhone
            };
        });
    }
    const showTextAlertModal = () => {
        setShowTextAlertForm(true);
    }

    const deleteAlert = (id) => {
        setAlertsToDelete([id]);
        setShowConfirmationModal(true);
    }

    const checkAddAlertToDeleteList = (id) => {
        if (alertsToDelete == id || alertsToDelete.includes(id)) {
            setAlertsToDelete(alertsToDelete.filter(a =>
                a !== id
            ));
        } else {
            setAlertsToDelete([...alertsToDelete,
                id]);
        }
    }

    const deleteBatchAlerts = () => {
        setShowConfirmationModal(true);
    }

    const checkPhoneConfirmation = () => {
        setDisableSubmit(true);
        let formattedPhone = intlTelInput.current?.getNumber();
        sandhillsRequest({
            url: routes.CheckShowSMSPhoneUpdateConfirmation,
            method: 'post',
            data: {
                smsPhone: formattedPhone,
                smsSignUpTypeID: smsType.listingAlerts
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((response) => {
            if (response.showConfirmation) {
                setDisableSubmit(false);
                setShowPhoneConfirmation(true);
            } else {
                saveEATextAlert();
            }
        }).catch((error) => {
            console.log(error);
            setDisableSubmit(false);
            setPhoneConfirmationCheckFailed(true);
        });
    }

    const submitEATextAlert = (subscribe, skipPhoneConfirmationCheck) => {
        setPhoneConfirmationCheckFailed(false);
        if (subscribe) {
            skipPhoneConfirmationCheck ? saveEATextAlert() : checkPhoneConfirmation();
        }
        else {
            toggleAlertsEnabled();
        }
    }


    const saveEATextAlert = () => {
        setDisableSubmit(true);

        setTextAlertModel(previousState => {
            return {
                ...previousState,
                PhoneNumber: intlTelInput.current?.getNumber(intlTelInputUtils?.numberFormat.INTERNATIONAL)
            };
        });

        sandhillsRequest({
            url: routes.SaveEmailAlertsTextAlert,
            method: 'post',
            data: textAlertModel,
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            setDisableSubmit(false);
            setShowPhoneConfirmation(false);
            setPhoneSubscribedSuccess(true);
            if (data) {
                setSMSPhone(textAlertModel.PhoneNumber);
            }
            setTextAlertModel(previousState => {
                return {
                    ...previousState,
                    alertsEnabled: data
                };
            });
            setTimeout(() => {
                setPhoneSubscribedSuccess(false);
                setShowTextAlertForm(false);
            }, 2500);
            setShowTextAlertHeader(true);
        });
    }
    const onChange = (e) => {
        setTextAlertModel(previousState => {
            return {
                ...previousState,
                PhoneNumber: intlTelInput.current?.getNumber(intlTelInputUtils?.numberFormat.INTERNATIONAL) ?? e.target.value
            };
        });
    }

    const titleSort = (type) => {
        let isAsc = !isAscending;

        let copy = [...emailAlerts];
        switch (type) {
            case 'category':
                if (isAsc) {
                    setEmailAlerts(copy.sort((a, b) => (a.CategoryDisplayName > b.CategoryDisplayName) ? 1 : -1));
                    setCatIconClass('fas fa-sort-amount-desc heavy');
                } else {
                    setEmailAlerts(copy.sort((a, b) => (a.CategoryDisplayName < b.CategoryDisplayName) ? 1 : -1));
                    setCatIconClass('fas fa-sort-amount-asc heavy');
                }
                setManuIconClass('fas fa-sort');
                setModelIconClass('fas fa-sort');
                break;
            case 'manufacturer':
                if (isAsc) {
                    setEmailAlerts(copy.sort((a, b) => (a.TypedManufacturer > b.TypedManufacturer) ? 1 : -1));
                    setManuIconClass('fas fa-sort-amount-desc heavy');
                } else {
                    setEmailAlerts(copy.sort((a, b) => (a.TypedManufacturer < b.TypedManufacturer) ? 1 : -1));
                    setManuIconClass('fas fa-sort-amount-asc heavy');
                }
                setCatIconClass('fas fa-sort');
                setModelIconClass('fas fa-sort');
                break;
            case 'model':
                if (isAsc) {
                    setEmailAlerts(copy.sort((a, b) => (a.Model > b.Model) ? 1 : -1));
                    setModelIconClass('fas fa-sort-amount-desc heavy');
                } else {
                    setEmailAlerts(copy.sort((a, b) => (a.Model < b.Model) ? 1 : -1));
                    setModelIconClass('fas fa-sort-amount-asc heavy');
                }
                setManuIconClass('fas fa-sort');
                setCatIconClass('fas fa-sort');
                break;
            default:
                break;
        }
        props.setEmailAlerts(copy)
        setEmailAlerts(copy);
        setIsAscending(isAsc);
    }

    const toggleAlertsEnabled = () => {
        setDisableSubmit(true);

        sandhillsRequest({
            url: routes.TurnOffTextAlerts,
            method: 'post',
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((data) => {
            setDisableSubmit(false);
            setPhoneRemovedSuccess(true);
            setShowDeletePhoneConfirmation(false);
            setTextAlertModel(previousState => {
                return {
                    ...previousState,
                    alertsEnabled: !data
                };
            });
            setTimeout(() => {
                setPhoneRemovedSuccess(false);
                setShowTextAlertForm(false);
                setDisableSubmit(false);
                setShowDeletePhoneConfirmation(false);
            }, 2500);
            setShowTextAlertHeader(false);
        });
    }

    const newForm = () => {
        setDisableNewForm(true);
        props.setFormData(previousState => {
            return {
                ...previousState,
                WantToBuyMessageID: 0,
                Model: '',
                CategoryID: '',
                CategoryDisplayName: '',
                TypedManufacturer: '',
                YearFrom: '',
                YearTo: '',
                PriceLimit: '',
                LanguageID: 'English',
                FitsToCategoryID: '',
                MileageMin: '',
                MileageMax: '',
                HorsepowerMin: '',
                HorsepowerMax: '',
                HoursMin: '',
                HoursMax: '',
                LengthInInches: '',
                LengthInFeet: '',
                WidthInInches: '',
                UserEnteredLocation: '',
                MaxDistance: '',
                Engine: '',
                TopClassificationCategoryID: '',
                ModelIsRequired: props.ModelIsRequired,
                AddToWatchlist: true,
                AvailableSpecs: [],
                EmailAlertsForAuction: true,
                EmailAlertsForSale: true 
            };
        });
        setShowNewForm(true);
        setEditMode(true);
        setTimeout(() => {
            document.getElementById('TypedManufacturer').scrollIntoView({ behavior: "smooth" });
        }, 125);
    };
    const submitForm = (e) => {
        let errors = props.runValidation();
        if (Object.keys(errors).length <= 0) {
            setValidationErrors([])
            props.submitForm(e, true);
        } else {
            setValidationErrors(errors);
        }
    }

    const infoPopup = () => {
        return (
            <div className='email-alert__popup'>
                <TranslationText tKey='sandhills.tradesites.mvc.savetowatchlistsummary' />
            </div>
        );
    }

    const headers = () => {
        return (
            <div className='alert-table-header'>
                <div className='email-alerts__select-all-checkbox' />
                {!props.HasClassifications || currentSite?.Site?.IsAuctionTime ?
                    <>
                        <div className='title-name' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); titleSort('category'); } }} onClick={() => { titleSort('category') }}><TranslationText tKey='sandhills.category' /><i className={catIconClass} /></div>
                        <div className='title-name' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); titleSort('manufacturer'); } }} onClick={() => { titleSort('manufacturer') }}><TranslationText tKey='sandhills.manufacturer' /><i className={manuIconClass} /></div>
                        <div className='title-name' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); titleSort('model'); } }} onClick={() => { titleSort('model') }}><TranslationText tKey='sandhills.model' /><i className={modelIconClass} /></div>
                        <div className='title-name watchlist'><TranslationText tKey='sandhills.tradepubwebsite.mvc.addtowatchlist' /><i className='fas fa-circle-info'></i>
                            {infoPopup()}</div>
                        {props.TextAlertFeatureEnabled && <div className='title-name text-alerts'><TranslationText tKey='sandhills.textalerts' /></div>}
                        <div>&nbsp;</div>
                    </>
                    :
                    <>
                        <div className='title-name_placeholder' />
                        <div className='title-name_placeholder' />
                        <div className='title-name_placeholder' />
                        <div className='title-name watchlist'><TranslationText tKey='sandhills.tradepubwebsite.mvc.addtowatchlist' /><i className='fas fa-info-circle'></i>
                            {infoPopup()}</div>
                        {props.TextAlertFeatureEnabled && <div className='title-name text-alerts'><TranslationText tKey='sandhills.textalerts' /></div>}
                        <div>&nbsp;</div>
                    </>}
            </div>
        );
    };

    return (
        <div className='email-alerts-list-box'>
            {props.formHeader(props.AlertTypeID)}
            {!props.HasClassifications ?
                <>
                    {emailAlerts?.length > 5 ?
                        <div className='alert-container-with-button'>
                            <div><TranslationText tKey='sandhills.pleasebesuretofillinmanumodelcatfieldsforemails' /></div>
                            <ThemedButton color={currentSite.ThemeOverride} className={'add-another-button-small button ts-button'} onClick={disableNewForm ? submitForm : newForm}>{disableNewForm ? <></> : <i className='fas fa-sharp fa-plus-square'></i>}{disableNewForm ? <TranslationText tKey='sandhills.savechanges' /> : <TranslationText tKey='sandhills.tradepubwebsite.mvc.addanalert' />}</ThemedButton>
                        </div>
                        :
                        <p className='helper-text'><TranslationText tKey='sandhills.pleasebesuretofillinmanumodelcatfieldsforemails' /></p>
                    }
                    {emailAlerts?.length == 0 || !emailAlerts &&
                        <div className="alert-error-message" >
                            <div className="error">
                                <TranslationText tKey="sandhills.tradepubwebsite.mvc.noemailalerts" />
                            </div>
                        </div >
                    }
                </>
                :
                <>
                    {emailAlerts?.length > 5 &&
                        <div className='another-button-top'>
                            <ThemedButton color={currentSite.ThemeOverride} className='add-another-button-small  button ts-button' onClick={disableNewForm ? submitForm : newForm}>{disableNewForm ? <></> : <i className='fas fa-sharp fa-plus-square'></i>}{disableNewForm ? <TranslationText tKey='sandhills.savechanges' /> : <TranslationText tKey='sandhills.tradepubwebsite.mvc.addanalert' />}</ThemedButton>
                        </div>
                    }
                </>}
            {showTextAlertHeader &&
                <div className='text-alert-header'>
                    <div>
                        {textAlertModel.AlertsEnabled ?
                            translator.translate('sandhills.tradesites.mvc.youaresigneduptoreceivetextalerts').replace('{0}', textAlertModel.PhoneNumber)
                            : translator.translate('sandhills.tradesites.mvc.stopreceivingtexts').replace('{0}', textAlertModel.PhoneNumber)}
                    </div>
                    <a role='button' tabIndex='0' onClick={showDeletePhoneConfirmationModal} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showDeletePhoneConfirmationModal(); } }}>
                        <strong>{translator.translate('sandhills.tradesites.mvc.turnofftextalerts')}</strong>
                    </a>&nbsp;&nbsp;<a role='button' tabIndex='0' onClick={showTextAlertModal} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showTextAlertModal(); } }}>
                        <strong>{translator.translate('sandhills.tradesites.mvc.editphonenumber')}</strong></a>
                    <br />
                    <span className='blurb-section' dangerouslySetInnerHTML={{ __html: props.TextAlertBlurb }} />
                </div>
            }
            <div className='alert-table'>

                {emailAlerts?.length > 0 ?
                    <span>
                        {!windowSize.isMobile && headers()}
                        {emailAlerts.map((obj, i) =>
                            <EmailAlertsInputForm
                                key={obj.WantToBuyMessageID}
                                id={i}
                                alert={obj}
                                SelectListItems={props.SelectListItems}
                                allowDistanceLimitation={props.AllowDistanceLimitation}
                                userEnteredLocation={props.userEnteredLocation}
                                handleLocationFieldChange={props.handleLocationFieldChange}
                                toggleWatchlist={props.toggleWatchlist}
                                toggleTextAlert={props.toggleTextAlert}
                                handleCurrencyChange={props.handleCurrencyChange}
                                validationErrors={validationErrors}
                                textChange={props.textChange}
                                getAutoCompleteCallback={props.getAutoCompleteCallback}
                                getAutoCompleteLocationUrl={props.getAutoCompleteLocationUrl}
                                enterUsersCurrentLocation={props.enterUsersCurrentLocation}
                                locationErrorMessage={props.locationErrorMessage}
                                formData={props.formData}
                                setFormData={props.setFormData}
                                submitForm={props.submitForm}
                                getAutoCompleteData={props.getAutoCompleteData}
                                getAutoCompleteUrl={props.getAutoCompleteUrl}
                                fieldChange={props.fieldChange}
                                runValidation={props.runValidation}
                                reloadPage={false}
                                editMode={editMode}
                                editLock={editLock}
                                deleteAlert={deleteAlert}
                                alertsToDelete={alertsToDelete}
                                addAlertToDeletion={checkAddAlertToDeleteList}
                                categoryContextOverride={props.categoryContextOverride}
                                ModelNotRequiredCats={props.ModelNotRequiredCats}
                                topClassificationIDSelected={props.formData.topClassificationIDSelected}
                                alertsEnabled={textAlertModel.AlertsEnabled}
                                showTextAlertModal={showTextAlertModal}
                                TextAlertFeatureEnabled={props.TextAlertFeatureEnabled}
                                setEmailAlerts={setEmailAlerts}
                                {...obj}
                            />)}
                    </span>
                    :
                    <div>
                        {!windowSize.isMobile && headers()}
                    </div>}
                {showNewForm &&
                    <EmailAlertsInputForm
                        SelectListItems={props.SelectListItems}
                        allowDistanceLimitation={props.AllowDistanceLimitation}
                        userEnteredLocation={props.userEnteredLocation}
                        handleLocationFieldChange={props.handleLocationFieldChange}
                        toggleWatchlist={props.toggleWatchlist}
                        toggleTextAlert={props.toggleTextAlert}
                        handleCurrencyChange={props.handleCurrencyChange}
                        validationErrors={validationErrors}
                        textChange={props.textChange}
                        getAutoCompleteCallback={props.getAutoCompleteCallback}
                        getAutoCompleteLocationUrl={props.getAutoCompleteLocationUrl}
                        enterUsersCurrentLocation={props.enterUsersCurrentLocation}
                        locationErrorMessage={props.locationErrorMessage}
                        formData={props.formData}
                        setFormData={props.setFormData}
                        submitForm={props.submitForm}
                        getAutoCompleteData={props.getAutoCompleteData}
                        getAutoCompleteUrl={props.getAutoCompleteUrl}
                        fieldChange={props.fieldChange}
                        runValidation={props.runValidation}
                        reloadPage={true}
                        editMode={true}
                        editLock={editLock}
                        key={'new-ea-form'}
                        alertsToDelete={alertsToDelete}
                        addAlertToDeletion={checkAddAlertToDeleteList}
                        categoryContextOverride={props.categoryContextOverride}
                        ModelNotRequiredCats={props.ModelNotRequiredCats}
                        setShowNewForm={setShowNewForm}
                        alertsEnabled={textAlertModel.AlertsEnabled}
                        topClassificationIDSelected={props.formData.topClassificationIDSelected}
                        showTextAlertModal={showTextAlertModal}
                        TextAlertFeatureEnabled={props.TextAlertFeatureEnabled}
                        setEmailAlerts={setEmailAlerts}
                        {...emptyForm}
                    />}
                {windowSize.isMobile && emailAlerts?.length > 0 &&
                    <BaseTypography className='mobile-disclaimer'>
                        *&nbsp;<TranslationText tKey='sandhills.tradesites.mvc.savetowatchlistsummary' /></BaseTypography>
                }               
                {showConfirmationModal &&
                    <DeleteConfirmationModal
                        message={translator.translate('sandhills.tradesites.mvc.areyoursuredeletealerts')}
                        submit={submitRemoveEAs}
                        onClose={closeConfirmationModal}
                    />
                }
                {showTextAlertForm &&
                    <EmailAlertsTextAlertModal
                    onClose={closeTextAlertModal}
                    onChange={onChange}
                    textAlertEnterNumberText={props.textAlertEnterNumberText}
                    textAlertOptOutText={props.textAlertOptOutText}
                    smsPhoneUpdateConfirmationText={props.SMSPhoneUpdateConfirmationText}
                    smsPhoneRemovalConfirmationText={props.SMSPhoneRemovalConfirmationText}
                    onSubmit={submitEATextAlert}
                    modalInfo={textAlertModel}
                    disableSubmit={disableSubmit}
                    phoneSubscribedSuccess={phoneSubscribedSuccess}
                    phoneRemovedSuccess={phoneRemovedSuccess}
                    intlTelInput={intlTelInput}
                    showPhoneConfirmation={showPhoneConfirmation}
                    showDeletePhoneConfirmation={showDeletePhoneConfirmation}
                    currentSMSPhone={smsPhone}
                    displayError={phoneConfirmationCheckFailed}
                    />
                }
                {alertsToDelete.length > 0 && !windowSize.isMobile &&
                    <div className='email-alerts__delete-popup'>
                        <div className='text-section'>
                            <div className='selection'>{alertsToDelete.length} {translator.translate('sandhills.selected')} <i tabIndex='0' role='button' aria-label={translator.translate('sandhills.closepage')} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setAlertsToDelete([]); } }} className='fas fa-times-circle' onClick={() => setAlertsToDelete([])} /></div>
                            <ThemedButton className='bulk-delete-button' onClick={deleteBatchAlerts}><i className='fas fa-trash-alt'></i> <TranslationText tKey='sandhills.Delete' /></ThemedButton>
                        </div>
                    </div>
                }
            </div>
            <div className='email-alerts__bottom-row'>
                <ThemedButton color={currentSite.ThemeOverride} className={currentSite?.Site?.IsBidcaller ? 'ts-button add-another-button' : 'add-another-button'} onClick={disableNewForm ? submitForm : newForm}>{disableNewForm ? <></> : <i className='fas fa-sharp fa-plus-square'></i>}{disableNewForm ? <TranslationText tKey='sandhills.savechanges' /> : <TranslationText tKey='sandhills.tradepubwebsite.mvc.addanalert' />}</ThemedButton>
            </div>
        </div>
    );
};

export default EmailAlertsListView;